// extracted by mini-css-extract-plugin
export default {"container":"PlanCard_container__JVXN+","top":"PlanCard_top__JtSXp","name":"PlanCard_name__2yP3n","amount":"PlanCard_amount__IgtlB","bottom":"PlanCard_bottom__W9GBW"};